import React from "react";

import { Link } from "react-router-dom";
import ApplyNowButton from "../../../../../components/applynowbutton";

const OutcomesYTS = () => {
  return (
    <div
      className=" py-10 mt-5 rounded-lg bg-gray-900 text-white relative"
      id="outcomes"
    >
      <div className="absolute inset-0 bg-black bg-opacity-50 z-10 rounded-lg"></div>
      <div className="h-full flex items-center justify-center relative z-20 px-10 text-center">
        <div className="max-w-4xl">
          <h2 className="md:text-3xl text-lg font-bold mb-4">
            Undergraduate Certificate/Diploma
          </h2>

          {/* Horizontal Line */}
          <div className="bg-sdorange h-1 w-10 mx-auto mb-4"></div>

          <p className="md:text-lg text-base leading-relaxed text-justify">
            This course can be taken as part of our Undergraduate Certificate
            (30 credits)/Diploma (60 credits) in Creative Diplomacy and
            Politics. This broader program offers students a comprehensive
            understanding of global affairs, diplomacy, & trade dynamics,
            preparing them for diverse career paths in the realm of
            international relations.
          </p>
        </div>
      </div>

      <div
        className="absolute inset-0 bg-cover bg-center rounded-lg"
        style={{ backgroundImage: "url('/image-fix/random-images/r5.jpg')" }}
      ></div>

      <ApplyNowButton />
    </div>
  );
};

export default OutcomesYTS;
